import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

const csrf = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
const pusherKey = import.meta.env.VITE_PUSHER_APP_KEY;

window.Echo = null;

if (pusherKey) {
  window.Pusher = Pusher;

  window.Echo = new Echo({
    broadcaster: 'pusher',
    key: pusherKey,
    cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER || 'mt1',
    wsHost: import.meta.env.VITE_PUSHER_HOST || window.location.hostname,
    wsPort: 443,
    wssPort: 443,
    forceTLS: true,
    enabledTransports: ['ws', 'wss'],
    disableStats: true,
    authEndpoint: '/broadcasting/auth',
    withCredentials: true,
    auth: {
      headers: {
        'X-CSRF-TOKEN': csrf,
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json',
      },
    },
  });
}
